import { __decorate } from "tslib";
import { Component, Prop, Emit, Vue, Watch } from "vue-property-decorator";
import ApiOrders from "@/api/ApiOrders";
import ApiEnter from "@/api/ApiEnter";
import sweetalert from "sweetalert";
let ContactInformation = class ContactInformation extends Vue {
    constructor() {
        super(...arguments);
        this.ModelData = {
            email: "",
            phone: "",
        };
    }
    closeModal() {
        return true;
    }
    setData() {
        this.ModelData.email = this.email;
        this.ModelData.phone = this.phone;
    }
    save() {
        return true;
    }
    async SaveData() {
        const response = await ApiOrders.UpdateContactInfo(ApiEnter.CurrentSessionUUID, this.$route.params.order_uuid, this.ModelData.phone, this.ModelData.email);
        if (response) {
            this.save();
        }
        else {
            sweetalert({
                title: "Error",
                text: "Error to change data",
                icon: "error",
            });
            this.closeModal();
        }
    }
};
__decorate([
    Prop()
], ContactInformation.prototype, "isOpen", void 0);
__decorate([
    Prop()
], ContactInformation.prototype, "email", void 0);
__decorate([
    Prop()
], ContactInformation.prototype, "phone", void 0);
__decorate([
    Emit("closeModal")
], ContactInformation.prototype, "closeModal", null);
__decorate([
    Watch("isOpen")
], ContactInformation.prototype, "setData", null);
__decorate([
    Emit("save")
], ContactInformation.prototype, "save", null);
ContactInformation = __decorate([
    Component({})
], ContactInformation);
export default ContactInformation;
